import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {EditReservationLog} from "../../../models/EditReservationLog";
import {environment} from "../../../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class EditReservationLogService {
    constructor(private _http: HttpClient) {}

    getEditReservationLog(id: number) {
        return this._http.get<EditReservationLog[]>(`${environment.API_URL}/reservations/getReservationLog/${id}`);
    }
}